export const ORDER_FILTERS = {
  in_delivery: 4,
  delivered: 5,
  paid_for: 3,
  unpaid: 2,
};

export const ORDER_STATUS_MAP = {
  1: { text: 'Новый', variant: 'warning' },
  2: { text: 'Не оплачен', variant: 'danger' },
  3: { text: 'Оплачен', variant: 'success' },
  4: { text: 'В доставке', variant: 'info' },
  5: { text: 'Доставлен', variant: 'primary' },
};
